import src from "IMAGE";
export default { src, width: 407, height: 152, blurWidth: 0, blurHeight: 0};
